module.exports = __webpack_public_path__ + "static/media/22@2x.c0184105.png";